import React from 'react';
import CounsellingLanding from "../../components/OnlineCounselling/counsellingLanding";
import { GetStaticPaths, GetStaticProps } from 'next';
import fetchUtil from '../../utils/fetchUtil';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import ErrorComponent from '../../components/ErrorComponent';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';


const OnlineCounciling: React.FC = (props: any) => {
    if (!props.pageData || props.pageData.length === 0) {
        return <ErrorComponent />
    }
    const { meta } = props.pageData[0]
    return (
        <>
            {meta && <MetaTagsComp {...meta} />}
            {props?.pageData?.length > 0 && <CounsellingLanding eventData={props.pageData[0]} />}
        </>
    )
}
export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: [], fallback: 'blocking' };
}

export const getStaticProps: GetStaticProps = async (context) => {
    const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/branch-office-promotions?slug=${context.params?.slug}`, 'GET', {}, '', false)
    return {
        props: {
            pageData
        },
        revalidate: CACHE_REVALIDATE_24H,
    };
}

export default OnlineCounciling;